export { default } from './CheckedOutItem';



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutItem/index.js